export const fieldsetCss = {
  border: 0,
  margin: "0 0 20px",
  padding: 0,
};
